import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { ROLES_QUERY } from '../graphql/queries'
import { FETCH_ROLES } from '../redux/action-types'
import { cleanupFetchRoles } from '../redux/actions'

const useRolesQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchRoles)

  const { isLoading, error, data, options } = useSelector(
    store => store.users.roles,
  )

  const refetch = useCallback(
    () => apolloService.query(ROLES_QUERY, {}, dispatch, FETCH_ROLES),
    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data, options }
}

export default useRolesQuery
